import { castArray } from 'vtils'
import { ImagePreview } from 'vant'
import { OneOrMore } from 'vtils/types'

export function previewImage(data: {
  images: OneOrMore<string>
  initialIndex?: number
  onClose?: () => any
}) {
  const images = castArray(data.images)
  ImagePreview({
    images: images,
    startPosition: data.initialIndex || 0,
    closeOnPopstate: true,
    showIndex: images.length > 1,
    onClose: data.onClose,
  })
}
